import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/summernote-lite.js';

class SummernoteEditor {
    constructor(selector, options = {}) {
        this.selector = selector;

        this.defaultOptions = {
            height: 300,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']],
                ['color', ['forecolor', 'backcolor']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link']],
                ['view', ['fullscreen']]
            ],
            // Set default background color
            styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            callbacks: {
                onInit: function() {
                    // Set default background color when editor is initialized
                    $('.note-editable').css('background-color', 'transparent');
                },
                onFocus: function() {
                    // Ensure background color is maintained on focus
                    $(this).css('background-color', '#f8f9fa');
                },
                onKeydown: function(e) {
                    // Apply default background color to new text
                    const self = this;
                    setTimeout(() => {
                        const selection = window.getSelection();
                        if (selection.rangeCount > 0) {
                            $(self).summernote('backColor', 'transparent');
                        }
                    }, 1);
                }
            }
        };
        this.options = { ...this.defaultOptions, ...options };
        this.init();
    }

    init() {
        if (typeof jQuery === 'undefined') {
            console.error('jQuery is required for Summernote');
            return;
        }

        $(this.selector).summernote(this.options);
    }

    // Get editor content
    getContent() {
        return $(this.selector).summernote('code');
    }

    // Set editor content
    setContent(content) {
        $(this.selector).summernote('code', content);
    }

    // Destroy editor
    destroy() {
        $(this.selector).summernote('destroy');
    }

    // Set default background color for the editor content area
    setBackgroundColor(color) {
        $(this.selector + ' .note-editable').css('background-color', color);
    }

    // Set default text color
    setTextColor(color) {
        $(this.selector + ' .note-editable').css('color', color);
    }

    // Apply background color to selected text or current position
    applyBackgroundToSelection(color) {
        $(this.selector).summernote('backColor', color);
    }

    // Get current background color
    getCurrentBackgroundColor() {
        return $(this.selector + ' .note-editable').css('background-color');
    }

    // Set default background color for new text content
    setDefaultTextBackground(color) {
        const self = this;
        $(this.selector).on('summernote.enter summernote.keyup', function() {
            // Apply background color to new content
            $(self.selector).summernote('backColor', color);
        });
    }

    // Initialize with default text background
    initWithDefaultBackground(editorBg = '#ffffff', textBg = null) {
        // Set editor background
        this.setBackgroundColor(editorBg);
        
        // Set default text background if provided
        if (textBg) {
            this.setDefaultTextBackground(textBg);
        }
    }

    // Insert text with specific background color
    insertTextWithBackground(text, backgroundColor = '#ffff99') {
        const styledText = `<span style="background-color: ${backgroundColor};">${text}</span>`;
        $(this.selector).summernote('pasteHTML', styledText);
    }
}

export { SummernoteEditor };